/**
 * Turns `RECIPIENT_FIRST_NAME` into a short, readable label (for unknown tokens
 * with no server registry entry).
 */
export function humanizePlaceholderToken(name: string): string {
  if (!name || !name.trim()) {
    return 'Unknown';
  }
  return name
    .toUpperCase()
    .split('_')
    .filter((p) => p.length > 0)
    .map((p) => p[0] + p.slice(1).toLowerCase())
    .join(' ');
}
